export default __webpack_public_path__ + "static/media/1987.1e6e846e.png";